import { SelectReport } from "../../../../Reports/shared/SelectReport.js";
import { useFormBuilderFieldsContext } from "../../../contexts/FormBuilderFieldsContext.js";
import { InternalContentBadge } from "../../../shared/InternalContentBadge.js";
import "react";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/FormBuilder/components/Fields/Report/Form.tsx
var ReportFieldForm = ({ config }) => {
	const { errorsByFieldId, fieldValueChanged, valuesByFieldId } = useFormBuilderFieldsContext();
	return /* @__PURE__ */ jsx(SelectReport, {
		error: errorsByFieldId[config.id],
		hint: /* @__PURE__ */ jsxs(Fragment$1, { children: [config.options.required && /* @__PURE__ */ jsx("span", {
			className: "text-color-critical text-sm font-light",
			children: "Required"
		}), config.internal && /* @__PURE__ */ jsx(InternalContentBadge, {})] }),
		isClearable: true,
		label: config.options.label || config.options.formLabel,
		onChangeValue: (val) => fieldValueChanged(config.id, val),
		value: valuesByFieldId[config.id],
		name: config.name,
		multi: config.options.multi,
		subText: config.options.subText
	});
};
//#endregion
export { ReportFieldForm };

//# sourceMappingURL=Form.js.map